function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

export default function () {
  return this.each(remove);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/selection/remove.js
// module id = 448
// module chunks = 0